import React from 'react';
import { Activity, Brain, Stethoscope, Heart, Ear, Bone, Users, Factory, ArrowRight } from 'lucide-react';
const caseTypes = [{
  icon: Activity,
  title: 'Personal Injury',
  description: 'RTA, slips and trips, workplace accidents, and public liability claims requiring independent medical evidence.',
  link: '/services/personal-injury',
  iconAlt: 'Medical activity icon representing personal injury assessment and clinical evaluation'
}, {
  icon: Stethoscope,
  title: 'Clinical Negligence',
  description: 'Screening, breach of duty, causation, and condition & prognosis reports for complex medical negligence claims.',
  link: '/services/clinical-negligence',
  iconAlt: 'Stethoscope icon representing clinical negligence medical examination and expert analysis'
}, {
  icon: Brain,
  title: 'Mental Health Assessments',
  description: 'PTSD, anxiety, depression, and capacity assessments by consultant psychiatrists and psychologists.',
  link: '/contact',
  iconAlt: 'Brain icon representing psychiatric and psychological assessment for medico-legal cases'
}, {
  icon: Bone,
  title: 'Orthopaedic Injuries',
  description: 'Fractures, spinal injuries, joint damage, and CRPS assessments with detailed prognosis and causation.',
  link: '/services/personal-injury',
  iconAlt: 'Bone icon representing orthopaedic injury assessment and musculoskeletal evaluation'
}, {
  icon: Ear,
  title: 'Hearing Loss & Tinnitus',
  description: 'Noise-induced hearing loss, tinnitus, and vestibular disorder reports for industrial disease claims.',
  link: '/services/industrial-disease',
  iconAlt: 'Ear icon representing audiological assessment for noise-induced hearing loss claims'
}, {
  icon: Users,
  title: 'Family Court',
  description: 'Independent medical assessments for care proceedings, custody disputes, and child protection cases.',
  link: '/services/family-court',
  iconAlt: 'Professional icon representing legal scales and family medical welfare for court reports'
}, {
  icon: Heart,
  title: 'Chronic Pain & Disability',
  description: 'Pain management evaluations, fibromyalgia assessments, and long-term disability impact reports.',
  link: '/contact',
  iconAlt: 'Heart icon representing chronic pain assessment and long-term disability evaluation'
}, {
  icon: Factory,
  title: 'Immigration & Criminal',
  description: 'Medical reports for asylum claims, immigration tribunals, criminal defence, and human rights cases.',
  link: '/services/immigration',
  iconAlt: 'Building icon representing immigration and criminal case medical assessments'
}];
export function CaseTypes() {
  return <section className="py-10 bg-white" aria-label="Medical case types and specialisms we cover" data-id="element-18">
      <div className="max-w-7xl mx-auto px-5 sm:px-6 lg:px-8" data-id="element-19">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-8" data-id="element-20">
          <div className="max-w-2xl" data-id="element-21">
            <h2 className="text-3xl md:text-4xl font-bold text-ink-900 tracking-tight mb-4" data-id="element-22">
              Case Types We Cover
            </h2>
            <p className="text-lg text-ink-500 leading-relaxed" data-id="element-23">
              From straightforward soft tissue injuries to complex
              multi-disciplinary claims — our panel covers every specialism.
            </p>
          </div>
          <a href="/contact" className="inline-flex items-center text-teal-600 font-semibold hover:text-teal-700 transition-colors whitespace-nowrap" data-id="element-24">
            Discuss your case <ArrowRight className="ml-2 h-4 w-4" data-id="element-25" />
          </a>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5" data-id="element-26">
          {caseTypes.map(item => <a key={item.title} href={item.link} className="group rounded-2xl border border-warm-200 bg-warm-50 p-6 hover:bg-white hover:shadow-md hover:border-teal-200 transition-all duration-300" data-id="element-27">
              <div className="w-10 h-10 bg-teal-50 rounded-lg flex items-center justify-center mb-4 group-hover:bg-teal-500 transition-colors duration-300" role="img" aria-label={item.iconAlt} data-id="element-28">
                <item.icon className="h-5 w-5 text-teal-600 group-hover:text-white transition-colors duration-300" aria-hidden="true" data-id="element-29" />
              </div>
              <h3 className="text-base font-bold text-ink-900 mb-2" data-id="element-30">
                {item.title}
              </h3>
              <p className="text-sm text-ink-500 leading-relaxed" data-id="element-31">
                {item.description}
              </p>
            </a>)}
        </div>
      </div>
    </section>;
}